import React, { useEffect, useState } from "react";
import '../../CSS/Actualite.css';
import ArticleComponent from "../composant_reutilisable/ArticleComponent";

// const articlesData = [
//     {
//         id: 1,
//         link: "https://www.benin.bj/ressources",
//         date: "Communiqués 21 septembre 2025",
//         title: "Un monde de splendeur : un joyau d’Afrique de l’Ouest où se mêlent culture vibrante, histoire fascinante et paysages singuliers",
//         image: "https://api.diplomatie.bj/upload/images//875390375113001758574783.png",
//         alt: "un-monde-splendeur-joyau-afrique-ouest-melent-culture-vibrante-histoire-fascinante-paysages-singuliers"
//     },
//     {
//         id: 2,
//         link: "/article/568/diaspora-etapes-simples-participer-elections-2026",
//         date: "Communiqués 08 septembre 2025",
//         title: "Diaspora : 3 étapes simples pour participer aux élections de 2026",
//         image: "https://api.diplomatie.bj/upload/images//642300757488001757347798.png",
//         alt: "diaspora-etapes-simples-participer-elections-2026"
//     }
// ];



const Communiques = () => {

  const [communiques, setCommuniques] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1); // page actuelle
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_items: 0,
    items_per_page: 10,
    total_pages: 1,
  });

  const fetchCommuniques = async (pageNumber = 1) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/embassy/articles?page=${pageNumber}`,
        {
          method: "GET",
          headers: { "code-ambassade": "uuidARBF0A1" },
        }
      );

      if (!response.ok) throw new Error("Erreur réseau");

      const data = await response.json();
      console.log("🔍 Données API:", data);

      if (data?.data) {

        // Filtrer seulement les articles de la catégorie "Communiqués"
        const communiques = data.data.filter(
          (a) => a.articleCategory === "Communiqués"
        );

        const formattedArticles = communiques.map((a) => ({
          id: a.id,
          link: a.url || `/article/${a.id}/${a.slug}`,
          date: `${a.articleCategory} ${new Date(a.date.date).toLocaleDateString(
            "fr-FR",
            { day: "2-digit", month: "long", year: "numeric" }
          )}`,
          title: a.title,
          image: a.banner
            ? a.banner.replace(/([^:]\/)\/+/g, "$1")
            : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8bikI-KUuM1IWosgqDRS5jyv2U_PPYlG6Tg&s",
          alt: a.slug,
        }));

        setCommuniques(formattedArticles);
        setPagination(data.pagination); // ⚡️ important
      }
    } catch (error) {
      console.error("Erreur de chargement :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommuniques(page);
  }, [page]);

  const goToPage = (num) => setPage(num);
  const prevPage = () => page > 1 && setPage(page - 1);
  const nextPage = () => page < pagination.total_pages && setPage(page + 1);

  // Génération dynamique des numéros de page
  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= pagination.total_pages; i++) {
      pages.push(
        <li key={i} className={`list ${i === page ? " warning" : ""}`}>
          <a
            className={`vt-5-in hz-20-in border ${i === page ? "pointer-events-none" : "pointer"
              }`}
            onClick={() => goToPage(i)}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };


  return (
    <div className="actualite-container">
      <div className="actualite-content">
        {loading ? (
          <p style={{ textAlign: "center" }}>Chargement des communiqués...</p>
        ) : communiques.length === 0 ? (
          <p style={{ textAlign: "center" }}>Aucun Communiqué disponible</p>
        ) : (
          <>
            <ArticleComponent articles={communiques} />

            {/* Pagination dynamique */}
            <div className="pagination">
              {/* Bouton Précédent — seulement si page > 1 */}
              {page > 1 && (
                <li className="list">
                  <a
                    className={`vt-5-in hz-5-in border ${page === 1 ? "pointer-events-none" : "pointer"}`}
                    onClick={prevPage}
                  >
                    ← Précédent
                  </a>
                </li>
              )}

              {renderPageNumbers()}

              {/* Bouton Suivant — seulement si page < total_pages */}
              {page < pagination.total_pages && (
                <li className="list">
                  <a
                    className={`vt-5-in hz-5-in border ${page === pagination.total_pages ? "pointer-events-none" : "pointer"}`}
                    onClick={nextPage}
                  >
                    Suivant →
                  </a>
                </li>
              )}
            </div>


            <p className="text-center mt-3">
              Page {page} sur {pagination.total_pages} — {pagination.total_items} résultats
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Communiques;